import React from 'react';
import { TinyColor } from '@ctrl/tinycolor';
import { useTheme } from '@emotion/react';
import { type CSSInterpolation } from '@emotion/serialize';
import { cs } from '@bbkAdminUtils/css-utils';
import { type EmotionTheme } from '@bbkFunnel/pages/theme';
import { useBaseInputStyles } from './text';

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  value?: string;
  classes?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  fullWidth?: boolean;
  placeholder?: string;
  name?: string;
  rows?: number;
  additionalStyles?: CSSInterpolation;
  modalTextColor?: boolean;
};
export const FunnelTextArea: React.FC<Props> = ({
  value,
  classes,
  onChange,
  onBlur,
  fullWidth = true,
  additionalStyles,
  modalTextColor,
  ...restProps
}) => {
  const theme = useTheme() as EmotionTheme;

  const baseInputStyles = useBaseInputStyles();

  const textColor = modalTextColor ? theme.modalTextColor : theme.textColor;
  const borderColor = modalTextColor ? theme.modalTextColor : theme.textColor;

  const inputStyles: CSSInterpolation = {
    width: fullWidth ? '100%' : 'auto',
    color: textColor,
    borderColor: new TinyColor(borderColor).setAlpha(0.4).toRgbString(),
    resize: 'none',
  };

  return (
    <textarea
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      css={[baseInputStyles, inputStyles, additionalStyles]}
      className={cs(classes, 'bbk-funnel-input')}
      rows={2}
      {...restProps}
    />
  );
};
